// Module-level Map<id, recording>. Binary audio/native file handles cannot
// live in redux, so the slice stores ids + serializable metadata and the saga
// resolves the actual submit payload here.

const store = new Map();

export const setBlob = (id, blob) => store.set(id, { platform: 'web', blob });
export const setNativeRecording = (id, recording) => store.set(id, {
  ...recording,
  nativePlatform: recording?.nativePlatform ?? recording?.platform,
  platform: 'native',
});
export const getRecording = (id) => store.get(id);
export const getBlob = (id) => store.get(id)?.blob;
export const clearBlob = (id) => store.delete(id);
export const clearAllBlobs = () => store.clear();


// what is meant by serializableCheck is that redux state should be serializable, 
// meaning it can be converted to a format that can be easily stored or transmitted (like JSON). 
// Blobs are not serializable, so they cannot be stored directly in the redux state.
//  Instead, we store their ids and metadata in the redux state and keep the actual Blob objects in this module-level Map. 
// This allows us to manage Blobs without violating the serializability constraint of redux.